import React from 'react';
import PropTypes from 'prop-types';
import { TIERS } from '../../../shared/playtest';
import { CURRENT_COLOR_BORDER, FRAME_RADIUS } from './playtestStyles';

const SPACING = { gap: 12, padding: 12 };
const LABEL_FONT_WEIGHT = 600;

const styles = {
  list: { display: 'flex', flexDirection: 'column', gap: SPACING.gap },
  option: {
    textAlign: 'left',
    padding: SPACING.padding,
    border: CURRENT_COLOR_BORDER,
    borderRadius: FRAME_RADIUS,
    background: 'transparent',
    color: 'inherit',
    cursor: 'pointer',
  },
  label: { fontWeight: LABEL_FONT_WEIGHT, display: 'block' },
};

/** Lists the four deck tiers in ascending order; choosing one starts play. */
const TierSelector = ({ onChoose }) => (
  <div data-testid="tier-selector" style={styles.list}>
    <h3>Choose a deck tier</h3>
    {TIERS.map((tier) => (
      <button
        type="button"
        key={tier.id}
        data-testid={`tier-option-${tier.id}`}
        style={styles.option}
        onClick={() => onChoose(tier.id)}
      >
        <span style={styles.label}>{tier.label}</span>
        <span data-testid={`tier-description-${tier.id}`}>{tier.description}</span>
      </button>
    ))}
  </div>
);

TierSelector.propTypes = {
  onChoose: PropTypes.func.isRequired,
};

export default TierSelector;
